import React from 'react';
import BorrowTab from 'features/borrow/BorrowTab';
const BorrowScreen = (props) => <BorrowTab {...props}/>;
export default BorrowScreen;
